<template>
  <span
    class="text-sm font-medium text-slate-700 dark:text-slate-300 flex items-center gap-1 mb-1"
    :class="{ 'text-red-600 dark:text-red-400': hasError }"
  >
    <slot>{{ label }}</slot>
    <span v-if="required" class="text-red-500 inline-flex items-center leading-none">*</span>
  </span>
</template>

<script>
export default {
  name: 'FormLabel',
  props: {
    label: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

